export const WORK_TYPE_OPTIONS = [
  { text: '상시 업무', value: 'always' },
  { text: '루틴 업무', value: 'routine' },
]

export const CYCLE_OPTIONS = [
  { text: '매주', value: 'weekly' },
  { text: '매월', value: 'monthly' },
]

export const MONTHLY_PUBLISH_DAY_OPTIONS = [
  ...Array.from({ length: 31 }, (_, index) => ({ text: `${index + 1}일`, value: index + 1 })),
  { text: '매월 말일', value: 'last' },
]

const VALID_CYCLE_TYPES = new Set(['manual', 'weekly', 'monthly'])
const DEFAULT_TITLE_RULE_BY_CYCLE = {
  weekly: '{year}년 {week}주차 업무',
  monthly: '{year}년 {month}월 업무',
}

const normalizeTitleRule = (cycleType, titleRule = '') => {
  const safeTitleRule = titleRule || ''
  if (cycleType === 'manual') return safeTitleRule
  return !safeTitleRule || Object.values(DEFAULT_TITLE_RULE_BY_CYCLE).includes(safeTitleRule)
    ? DEFAULT_TITLE_RULE_BY_CYCLE[cycleType]
    : safeTitleRule
}

const buildScheduleRule = (cycleType, scheduleRule = {}) => {
  const safeScheduleRule = scheduleRule || {}
  const publishTime = safeScheduleRule.publish_time || '09:00'
  if (cycleType === 'manual') return null
  if (cycleType === 'monthly') {
    const rawDay = safeScheduleRule.publish_day_of_month
    const numericDay = Number(rawDay)
    const publishDay = rawDay === 'last'
      ? 'last'
      : Number.isInteger(numericDay) && numericDay >= 1 && numericDay <= 31
        ? numericDay
        : 1
    return { publish_day_of_month: publishDay, publish_time: publishTime }
  }
  return {
    publish_day_of_week: safeScheduleRule.publish_day_of_week || 'monday',
    publish_time: publishTime,
  }
}

export const getTemplateWorkType = cycleType => cycleType === 'manual' ? 'always' : 'routine'

export const getTemplateScheduleVisibility = cycleType => ({
  routine: cycleType !== 'manual',
  weekly: cycleType === 'weekly',
  monthly: cycleType === 'monthly',
})

export const normalizeTemplateSchedule = (form = {}) => {
  const cycleType = VALID_CYCLE_TYPES.has(form.cycle_type) ? form.cycle_type : 'weekly'
  const scheduleRule = form.schedule_rule ?? {
    publish_day_of_week: form.publish_day_of_week,
    publish_day_of_month: form.publish_day_of_month,
    publish_time: form.publish_time,
  }
  return {
    ...form,
    cycle_type: cycleType,
    status: cycleType === 'manual' ? 'active' : form.status || 'active',
    schedule_rule: buildScheduleRule(cycleType, scheduleRule),
    period_key_rule: cycleType === 'manual' ? '' : form.period_key_rule || '',
    title_rule: normalizeTitleRule(cycleType, form.title_rule),
  }
}

export const changeTemplateWorkType = (form, workType) => normalizeTemplateSchedule({
  ...form,
  cycle_type: workType === 'always'
    ? 'manual'
    : form.cycle_type === 'manual'
      ? 'weekly'
      : form.cycle_type,
  schedule_rule: workType === 'routine' && form.cycle_type === 'manual' ? {} : form.schedule_rule,
  period_key_rule: workType === 'routine' && form.cycle_type === 'manual' ? 'iso_week' : form.period_key_rule,
})

export const changeTemplateCycleType = (form, cycleType) => normalizeTemplateSchedule({
  ...form,
  cycle_type: cycleType,
  schedule_rule: {},
  period_key_rule: cycleType === 'monthly' ? 'month' : 'iso_week',
})

export const buildTemplateSchedulePayload = form => {
  const normalized = normalizeTemplateSchedule(form)
  return {
    cycle_type: normalized.cycle_type,
    status: normalized.status,
    schedule_rule: normalized.schedule_rule,
    period_key_rule: normalized.period_key_rule,
  }
}

export const buildWorkTemplateBasePayload = form => {
  const normalized = normalizeTemplateSchedule(form)
  return {
    project_id: form.project_id,
    name: form.name,
    description: form.description || '',
    ...buildTemplateSchedulePayload(normalized),
    title_rule: normalized.title_rule,
    timezone: form.timezone || 'Asia/Seoul',
  }
}

export const buildWorkTemplateUpdatePayload = form => {
  const payload = buildWorkTemplateBasePayload(form)
  if (payload.cycle_type === 'manual') delete payload.schedule_rule
  return payload
}
